import { useEffect, useRef } from 'react';
import type { PipelineStep } from '../../types';

interface LiveStatusProps {
  progressStep?: PipelineStep | null;
  progressMessage?: string;
  planningTokens?: string;
}

const THINKING_TAIL_CHARS = 140;

export function LiveStatus({
  progressStep,
  progressMessage,
  planningTokens,
}: LiveStatusProps) {
  const showThinking =
    progressStep === 'planning' &&
    typeof planningTokens === 'string' &&
    planningTokens.length > 0;

  const cleanMessage = progressMessage?.replace(/(\.{2,}|…)+$/, '').trimEnd();
  const statusText = cleanMessage || (progressStep ? 'Working' : 'Starting');

  const thinkingTail = showThinking
    ? planningTokens!.slice(-THINKING_TAIL_CHARS).replace(/\s+/g, ' ')
    : '';

  return (
    <div className="malpedia-live-status">
      <div className="malpedia-live-status-line" aria-live="polite">
        <span className="malpedia-live-status-dot" aria-hidden="true" />
        <span className="malpedia-live-status-text">
          {statusText}
          <span className="malpedia-live-status-ellipsis" aria-hidden="true" />
        </span>
      </div>
      {showThinking && (
        <ThinkingTail text={thinkingTail} />
      )}
    </div>
  );
}

function ThinkingTail({ text }: { text: string }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (el) {
      el.scrollLeft = el.scrollWidth;
    }
  }, [text]);

  return (
    <div className="malpedia-live-thinking-line" ref={ref} aria-hidden="true">
      <span className="malpedia-live-thinking-text">{text}</span>
    </div>
  );
}
